module.exports = __webpack_public_path__ + "static/icons/icon-airport-transfers-7a97c0e3cbc970dc151e2a308a7eee4c.svg";